import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export interface StorageTypesFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

interface GetStorageTypesParams {
  filters?: StorageTypesFilterParams;
  signal?: AbortSignal;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getStorageTypesAPI =
  ({ filters, onSuccess, onError, signal }: GetStorageTypesParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/product-types", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result?.data);
      } else {
        message.error(result?.message || "Failed to fetch storage types");
        onError?.();
      }
    } catch (error: any) {
      if (
        error?.name === "CanceledError" ||
        error?.code === "ERR_CANCELED" ||
        error?.name === "AbortError"
      ) {
        return;
      }
      console.error("Get Storage Types error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to fetch storage types";
      message.error(errorMessage);
    }
  };

export const getSageProductGroupsAPI =
  ({
    filters,
    onSuccess,
    onError,
    signal,
  }: {
    filters?: any;
    onSuccess?: (data: any) => void;
    onError?: () => void;
    signal?: AbortSignal;
  }) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/sage/product-groups", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result?.data);
      } else {
        onError?.();
      }
    } catch (error: any) {
      if (
        error?.name === "CanceledError" ||
        error?.code === "ERR_CANCELED" ||
        error?.name === "AbortError"
      ) {
        return;
      }
      console.error("Get Sage Product Groups error:", error);
      onError?.();
    }
  };

export interface UpdateStorageTypePayload {
  id: string;
  name: string;
  sage_product_group_id?: string | number | null;
  sage_product_group_code?: string | null;
  [key: string]: any;
}

interface UpdateStorageTypeParams {
  payload: UpdateStorageTypePayload;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const updateStorageTypeAPI =
  ({ payload, onSuccess, onError }: UpdateStorageTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put("/product-types", payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Storage type updated successfully");
        onSuccess?.(result?.data);
      } else {
        message.error(result?.message || "Failed to update storage type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Storage Type error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to update storage type";
      message.error(errorMessage);
    }
  };
